
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1B365D] text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-[#2BB6A3] rounded-lg flex items-center justify-center">
                <i className="ri-flashlight-line text-white text-xl"></i>
              </div>
              <span className="text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                SparkBoost Labs
              </span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              We help service-based companies build predictable revenue systems that scale beyond founder-led sales. 
              Transform your business with AI-powered automation and proven growth methodologies.
            </p>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-[#2BB6A3]"></i>
                <span>9542 Bevon Pl, Tujunga, CA 91042</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-[#2BB6A3]"></i>
                <span>(310) 650-2551</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-[#2BB6A3]"></i>
                <span>info@sparkboostlabs.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#2BB6A3] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#2BB6A3] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/case-studies" className="text-gray-300 hover:text-[#2BB6A3] transition-colors">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#2BB6A3] transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-[#2BB6A3] transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#2BB6A3] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#2BB6A3] transition-colors">
                  AI-Powered Outbound Automation
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#2BB6A3] transition-colors">
                  Sales Process Optimization
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#2BB6A3] transition-colors">
                  Authority-Building Content
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#2BB6A3] transition-colors">
                  Revenue Operations
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 SparkBoost Labs. All rights reserved.
            </div>
            <div className="flex items-center space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-[#2BB6A3] text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-[#2BB6A3] text-sm transition-colors">
                Terms of Service
              </Link>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#2BB6A3] text-sm transition-colors"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
